export const UNIFIED_DIALOG_PAPER_SX = {
  borderRadius: 'var(--mat-dialog-container-shape, 4px)',
  boxShadow: 'var(--mat-dialog-container-elevation-shadow, 0px 11px 15px -7px rgba(0, 0, 0, .2), 0px 24px 38px 3px rgba(0, 0, 0, .14), 0px 9px 46px 8px rgba(0, 0, 0, .12))',
  backgroundColor: 'var(--mat-dialog-container-color, white)',
  color: 'var(--mat-app-text-color, rgba(0, 0, 0, .87))',
  fontFamily: 'Roboto, sans-serif',
  pointerEvents: 'auto',
  p: 0,
  boxSizing: 'border-box',
  outline: 0,
  width: 'min(80vw, var(--mat-dialog-container-max-width, 80vw))',
  maxWidth: 'var(--mat-dialog-container-max-width, 80vw)',
  minWidth: 'var(--mat-dialog-container-min-width, 0)',
  height: '80vh',
  maxHeight: '80vh',
  m: 3,
};

export const COMPACT_DIALOG_PAPER_SX = {
  ...UNIFIED_DIALOG_PAPER_SX,
  width: 'min(640px, calc(100vw - 48px))',
  maxWidth: 'min(640px, calc(100vw - 48px))',
  height: 'auto',
  maxHeight: 'min(560px, calc(100vh - 48px))',
};